import React, { useState, useEffect } from "react";
import {
  Center,
  Box,
  Image,
  VStack,
  Text,
  Heading,
  Stack,
  SimpleGrid,
  GridItem,
  Divider,
  Button,
} from "@chakra-ui/react";
import { Navigate } from "react-router-dom";
import Navbar from "../components/navbar/Navbar";
import AvatarMenu from "../components/navbar/avatar-menu";
import HomeSidebarContent from "../components/home/home-sidebar-content";
import NavbarLinks from "../components/navbar/NavbarLinks";
import Footer from "../components/footer";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const Return = () => {
  const [status, setStatus] = useState("");
  const [orderDetails, setOrderDetails] = useState('');

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get("session_id");

    fetch(`${backendUrl}/api/status`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then((res) => res.json())
      .then((data) => {
        setStatus(data.status);
        setOrderDetails(data);
      });
  }, []);

  if (status === "open") {
    return <Navigate to="/checkout" />;
  }

  if (status === "complete" && orderDetails) {
    return (
      <>
        <Navbar
          sidebarContent={<HomeSidebarContent />}
          links={<NavbarLinks />}
          buttons={<AvatarMenu />}
        />
        <Center>
          <Stack
            direction={{ base: "column", lg: "row" }}
            boxShadow="2xl"
            h={"auto"}
            w={"100%"}
            borderRadius="15px"
            overflow={"hidden"}
            margin={"1rem 3% 3rem 3%"}
            bg={"white"}
          >
            <Box w={{ base: "100%", lg: "50%" }}>
              <Image src={orderDetails.car.photo1} objectFit="cover" h={"full"} />
            </Box>
            <Box w={{ base: "100%", lg: "50%" }} p={"5%"} bg={"white"} h={"full"}>
              <VStack alignItems={"center"} spacing={"3"}>
                <Heading fontWeight={"500"}>Order Successful!</Heading>
                <Text>Thank you for your purchase, {orderDetails.c_name}!</Text>
                <Divider borderColor="gray.300" py={3} />
                <SimpleGrid w={"full"} columns={2} py={3} textAlign="left">
                  <GridItem>
                    <Text fontWeight="600" color="gray.600">Rental Date:</Text>
                    <Text>{orderDetails.rental_date}</Text>
                  </GridItem>
                  <GridItem>
                    <Text fontWeight="600" color="gray.600">Return Date:</Text>
                    <Text>{orderDetails.return_date}</Text>
                  </GridItem>
                  <GridItem>
                    <Text fontWeight="600" color="gray.600">Price:</Text>
                    <Text>${orderDetails.price}</Text>
                  </GridItem>
                  <GridItem>
                    <Text fontWeight="600" color="gray.600">Driver:</Text>
                    <Text>{orderDetails.driver ? "Yes" : "No"}</Text>
                  </GridItem>
                  <GridItem colSpan={2}>
                    <Text fontWeight="600" color="gray.600">Address:</Text>
                    <Text>
                      {orderDetails.address.line1}, {orderDetails.address.line2 && `${orderDetails.address.line2}, `}{orderDetails.address.city}, {orderDetails.address.state} {orderDetails.address.postal_code}, {orderDetails.address.country}
                    </Text>
                  </GridItem>
                </SimpleGrid>
                <Divider borderColor="gray.300" py={3} />
                <SimpleGrid w={"full"} columns={2} py={3} textAlign="left">
                  <GridItem>
                    <Text fontWeight="600" color="gray.600">Car:</Text>
                    <Text>{orderDetails.car.brand} {orderDetails.car.model}</Text>
                  </GridItem>
                  <GridItem>
                    <Text fontWeight="600" color="gray.600">Gearbox:</Text>
                    <Text>{orderDetails.car.gearbox}</Text>
                  </GridItem>
                  <GridItem>
                    <Text fontWeight="600" color="gray.600">Fuel Type:</Text>
                    <Text>{orderDetails.car.fuel_type}</Text>
                  </GridItem>
                </SimpleGrid>
                <Divider borderColor="gray.300" py={3} />
                <Button onClick={() => window.print()}>Print Receipt</Button>
              </VStack>
            </Box>
          </Stack>
        </Center>
        <Footer />
      </>
    );
  }

  return <Navigate to="/" />;
};

export default Return;
